/* eslint-disable no-console */
import { useZustandStore } from 'hooks/useZustandStore';
import { featureFlagClient } from 'utils';
import { zustandDialogStore } from '../../zustandStores/dialogStore';
import type { IDialog, TDialogKey } from './DialogStore.types';

export const useDialogStore = () => {
  const dialogStoreRefactorJson = featureFlagClient.getJSON(
    'dialogStoreRefactorFeature',
  );

  const { dialogs, setDialogs } = useZustandStore(
    zustandDialogStore,
    store => ({
      dialogs: store.dialogs,
      setDialogs: store.setDialogs,
    }),
  );

  const keyExists = (key: TDialogKey) => {
    const currentDialogs = zustandDialogStore.getState().dialogs;
    return !!currentDialogs.find(dialog => dialog.key === key);
  };

  const addDialog = (dialog: IDialog) => {
    const currentDialogs = zustandDialogStore.getState().dialogs;

    if (keyExists(dialog.key)) {
      console.warn(`Duplicate key: ${dialog.key} found in dialogStore`);
    }

    const newDialogs = [dialog, ...currentDialogs];
    setDialogs(newDialogs);
  };

  const removeDialog = (key: TDialogKey) => {
    const currentDialogs = zustandDialogStore.getState().dialogs;

    if (!keyExists(key)) {
      console.warn(`Key: ${key} does not exist in dialogStore`);
    }

    const newDialogs = currentDialogs.filter(dialog => dialog.key !== key);
    setDialogs(newDialogs);
  };

  const removeAllDialogs = () => {
    setDialogs([]);
  };

  const isUsingNewArchitecture = (key: TDialogKey) =>
    dialogStoreRefactorJson.enabled &&
    dialogStoreRefactorJson.enabledDialogs?.includes(key);

  return {
    dialogs,
    addDialog,
    removeDialog,
    removeAllDialogs,
    isDialogVisible: keyExists,
    isUsingNewArchitecture,
  };
};
